import SharedCustomersServices from "../classes/SharedCustomersServices";
import { $localStorage } from "../../features";

const defaultState = () => ({
  data: [],
  apply_group_by:
    $localStorage.get("shared_customers_services_list.apply_group_by") || [],
  filter_string:
    $localStorage.get("shared_customers_services_list.filter_string") || "",
  filter_strings:
    $localStorage.get("shared_customers_services_list.filter_strings") || []
});

const state = defaultState();

// getters
const getters = {
  services: () => (skip_filters = false) => {
    if (!state.apply_group_by.length) {
      if (!skip_filters && (state.filter_string || state.filter_strings)) {
        return state.data.filter(v =>
          v.beShownForFilterString(state.filter_string, state.filter_strings)
        );
      }
      return state.data;
    }
    return state.data.reduce((r, v) => {
      if (
        !skip_filters &&
        (state.filter_string || state.filter_strings) &&
        !v.beShownForFilterString(state.filter_string, state.filter_strings)
      ) {
        return r;
      }
      let path = "r";
      for (let i = 0; i < state.apply_group_by.length; i++) {
        let key = v[state.apply_group_by[i]];
        path += `["${key}"]`;
        eval(path) || eval(path + `={}`);
      }
      if (!(eval(path) instanceof Array)) {
        eval(path + "=[]");
      }
      eval(path).push(v);
      return r;
    }, {});
  },
  group_by() {
    return SharedCustomersServices.canGroupBy.filter(v => {
      return !state.apply_group_by.includes(v);
    });
  }
};

// actions
const actions = {
  shared_customers_services_list(store, data) {
    store.commit("setData", data);
  }
};

// mutations
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  setData(state, data) {
    state.data = SharedCustomersServices.getSelfList(data, []);
  },
  addToApplyGroupBy(state, group_name) {
    if (!SharedCustomersServices.canGroupBy.includes(group_name)) {
      return;
    }
    state.apply_group_by.push(group_name);
    $localStorage.set(
      "shared_customers_services_list.apply_group_by",
      state.apply_group_by
    );
  },
  deleteFromApplyGroupBy(state, group_name) {
    state.apply_group_by.splice(state.apply_group_by.indexOf(group_name), 1);
    $localStorage.set(
      "shared_customers_services_list.apply_group_by",
      state.apply_group_by
    );
  },
  addToFilterStrings(state) {
    if (
      state.filter_string &&
      !state.filter_strings.includes(state.filter_string)
    ) {
      state.filter_strings.push(state.filter_string);
      state.filter_string = "";
    }
    $localStorage.set(
      "shared_customers_services_list.filter_strings",
      state.filter_strings
    );
    $localStorage.set(
      "shared_customers_services_list.filter_string",
      state.filter_string
    );
  },
  deleteFromFilterStrings(state, string) {
    state.filter_strings.splice(state.filter_strings.indexOf(string), 1);
    $localStorage.set(
      "shared_customers_services_list.filter_strings",
      state.filter_strings
    );
  },
  clearAllFilters(state) {
    $localStorage.set(
      "shared_customers_services_list.filter_strings",
      (state.filter_strings = [])
    );
    $localStorage.set(
      "shared_customers_services_list.filter_string",
      (state.filter_string = "")
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
